import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
export function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'About',
    href: '#about'
  }, {
    name: 'Experience',
    href: '#experience'
  }, {
    name: 'Skills',
    href: '#skills'
  }, {
    name: 'Contact',
    href: '#contact'
  }];
  return <motion.nav initial={{
    y: -100
  }} animate={{
    y: 0
  }} transition={{
    duration: 0.6,
    ease: 'easeOut'
  }} className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white/90 backdrop-blur-md shadow-sm py-4' : 'bg-transparent py-6'}`} data-id="element-77">
      <div className="max-w-[1200px] mx-auto px-6 md:px-12 flex justify-between items-center" data-id="element-78">
        <a href="#" className={`font-serif font-bold text-xl tracking-tight transition-colors duration-300 ${scrolled ? 'text-primary' : 'text-white'}`} data-id="element-79">
          JC.
        </a>
        <ul className="hidden md:flex items-center gap-8" data-id="element-80">
          {navLinks.map(link => <li key={link.name} data-id="element-81">
              <a href={link.href} className={`font-sans text-sm font-medium transition-colors relative group ${scrolled ? 'text-charcoal hover:text-primary' : 'text-white/80 hover:text-white'}`} data-id="element-82">
                {link.name}
                <span className={`absolute -bottom-1 left-0 w-0 h-[1px] transition-all duration-300 group-hover:w-full ${scrolled ? 'bg-primary' : 'bg-white'}`} data-id="element-83"></span>
              </a>
            </li>)}
        </ul>
        <a href="#contact" className={`md:hidden font-sans text-sm font-medium transition-colors ${scrolled ? 'text-primary' : 'text-white'}`} data-id="element-84">
          Contact
        </a>
      </div>
    </motion.nav>;
}